import React, { Component }  from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Header from './Header'
import { 
  Table,
  Spin,
  Switch 
} from 'antd'
import {
  getAllPrefixList,
  onUpdatePrefix,
  onUpdateMoveRow,
} from '../../redux/prefix/action'
import { DndProvider, DragSource, DropTarget } from 'react-dnd-cjs'
import HTML5Backend from 'react-dnd-html5-backend-cjs'
import update from 'immutability-helper'
import ModalPrefix from './ModalPrefix'
import styles from './Prefix.module.scss'
import Edit from '../IconSVG/Edit.svg'
import EditGray from '../IconSVG/EditGray.svg'
import Delete from '../IconSVG/Delete.svg'
import DeleteGray from '../IconSVG/DeleteGray.svg'
import IconMoveRow from '../IconSVG/IconMoveRow.svg' 

let dragingIndex = -1

class BodyRow extends React.Component {
  render() {
    const { isOver, connectDragSource, connectDropTarget,  ...restProps } = this.props
    const style = { ...restProps.style, cursor: 'move' } 
    let { className } = restProps
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward'
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward'
      }
    }
    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    )
  }
} 
const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index
    return {
      index: props.index,
    }
  },
} 
const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index  
    if (dragIndex === hoverIndex) {
      return
    }  
    props.moveRow(dragIndex, hoverIndex)  
    monitor.getItem().index = hoverIndex
    
  },
}  
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor ) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver() 
})) (
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource(),
    
  }))(BodyRow)) 

class Prefix extends Component {
  constructor(props){
    super(props)
    this.state = { 
      isLoading: false,
      prefixData: [],
      indexRow: false,
      checkMouseOverEdit: false,
      checkMouserOverDelete: false,
      modalVisible: false, 
      item: {},
      typeModal: false,
      switchData: { 
        visible: {}
      },
      prefixItems: []
    }
  }

  columns = [
    {
      title: '',
      dataIndex: '',
      key: 'drag',
      render:()=> {
        return ( <img alt='icon-move-row' src={IconMoveRow}/>)
      },
      width:'30px'
    },
    {
      title: ()=> {
        return (<span>คำนำหน้าชื่อ</span>)
      },
      dataIndex: 'name',
      key: 'name',
      width: '150px'
    },
    {
      title: 'นักเรียน',
      dataIndex: 'visible',
      key: 'student',
      render:(visible,record) => {
        return (<Switch 
          checkedChildren = 'เปิด'
          unCheckedChildren = 'ปิด'
          checked = {visible.student ? true : false }
          onChange={(checked,e) => {
            e.stopPropagation()
            this.onSwitch(record,checked,'student') 
          }}/>)
      },
      width: '100px',
      align: 'center'
    },
    {
      title: 'ครู/ครูพิเศษ/ผู้ปกครอง',
      dataIndex: 'visible',
      key: 'teacher',
      render:(visible,record) => {
        return (<Switch
          checkedChildren = 'เปิด'
          unCheckedChildren = 'ปิด'
          checked = { visible.teacher ? true : false }
          onChange={(checked,e) => {
            e.stopPropagation()
            this.onSwitch(record,checked,'teacher') 
          }}
        />)
      },
      width: '200px',
      align: 'center'
    },
    {
      title: '',
      dataIndex: '',
      key: 'edit',
      render:(edit,record,index)=> {
        const { checkMouseOverEdit, indexRow } = this.state
        const mouserOver = () => {
          this.setState({ checkMouseOverEdit: true })
        }
        const mouseLeave = () => {
          this.setState({ checkMouseOverEdit: false})
        }
        return (
          <div className={styles.icon_row} >
            <img alt='edit' title='แก้ไข' onClick={e => {
              e.stopPropagation()
              this.onOpenModal(index,'edit')
            }} onMouseOver={mouserOver}  onMouseLeave={mouseLeave} src={checkMouseOverEdit && indexRow === index ? Edit : EditGray}/></div>
        )
      },
      width: '50px'
    },
    {
      title: '',
      dataIndex: '',
      key: 'delete',
      render:(deleteRow,record,index)=> {
        const { checkMouserOverDelete, indexRow } = this.state
        const mouserOver = () => {
          this.setState({ checkMouserOverDelete: true })
        }
        const mouseLeave = () => {
          this.setState({ checkMouserOverDelete: false})
        }
        return (
          <div className={styles.icon_row}>
            <img alt='delete' title='ลบข้อมูล' onClick={e=>{
              e.stopPropagation()
              this.onOpenModal(index,'delete')
            }} onMouseOver={mouserOver} onMouseLeave={mouseLeave} src={ checkMouserOverDelete && indexRow === index ? Delete : DeleteGray}/></div>
        )
      }
    },
  ]

  components = {
    body: {
      row: DragableBodyRow,
    },
  }

  componentDidMount = () => {
    this.fetchPrefixName()  
  }
  fetchPrefixName = async() => {
    this.setState({ isLoading: true })
    const res = await this.props.getAllPrefixList() 
    this.setState({ 
      prefixData: res,
      prefixItems: res.items,
      isLoading: false 
    })
  }
  
  moveRow = async(dragIndex, hoverIndex) => {
    const { prefixItems } = this.state  
    const dragRow = prefixItems[dragIndex] 
    let data = { seq: hoverIndex }
    await this.setState(
      update(this.state, {
        prefixItems: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
        },
      }), 
    ) 
    await this.props.onUpdateMoveRow(prefixItems[dragIndex]._id,data)
  }
  onSwitch = async(record,checked,role) => {
    const { switchData } = this.state
    this.setState({ isLoading: true}) 
    if(role === 'student'){
      switchData.visible = { student: checked }
    }else{
      switchData.visible = { teacher: checked }
    }  
    await this.props.onUpdatePrefix(record._id,switchData) 
    this.setState({ isLoading: false})
    this.fetchPrefixName() 
  } 
  onOpenModal = (index, type) => {  
    const { prefixData } = this.state 
    this.setState({
      typeModal: type,
      item: prefixData.items[index],
      modalVisible: true
    })
  } 
  onCloseModal = () => {
    this.setState({
      modalVisible: false
    })
  }
  render(){
    const { isLoading, prefixItems, modalVisible, item, typeModal } = this.state  
    return ( 
      <div>
        <Spin size='large' tip='Loading...' spinning={ isLoading }>
          <Header onOpenModal={this.onOpenModal}/>
          <DndProvider backend={HTML5Backend}>
            <Table
              scroll={{x:true}}
              rowKey={ (record,i) => i }
              columns={this.columns}
              dataSource={prefixItems} 
              components={this.components}
              pagination={false}
              onRow={(record, index) => ({
                index,
                moveRow: this.moveRow,
                onMouseEnter: ()=> this.setState({ indexRow: index })
              })}
            />
          </DndProvider> 
          <ModalPrefix prefixItems={prefixItems} fetch={this.fetchPrefixName} typeModal={typeModal} items={item} modalVisible={modalVisible} onCloseModal={this.onCloseModal}/>
        </Spin> 
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {   
    
  }
}
const mapDispatchToProps = dispatch => 
  bindActionCreators(
    { 
      getAllPrefixList,
      onUpdatePrefix,
      onUpdateMoveRow
    },
    dispatch
  )

export default connect(mapStateToProps,mapDispatchToProps)(Prefix)